module.exports = __webpack_public_path__ + "img/MNGCode.9aab6648.svg";